import { render } from "./BLoader.vue?vue&type=template&id=159369ee&ts=true"
import script from "./BLoader.vue?vue&type=script&lang=ts"
export * from "./BLoader.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/malo/Documents/lamasign/be-right-vue3-lib 15.25.31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__